import React from 'react';
import Logo from '../assets/images/logo-1.png';

export default function Support() {
    return (
        <>
            <div className="container-fluid">
                <div className="row mt-5 mb-5">
                    <div className="col-12 text-center col-sm-6 m-auto">
                        <img src={Logo} height="90px" alt="" />
                    </div>
                </div>   
                <div className="row">
                    <div className="col-12 col-sm-6 m-auto mb-4">
                        <div className="card shadow h-100 py-2 m-auto">
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-12 text-center">
                                        <h3 className="text-primary">Support</h3>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12">
                                        <br/>
                                        <div id="Translation">
                                            <p>If you have any issue, please send an email to support@puresocial.cx with the following information:</p><ul><li>Full name</li><li>Your work e-mail address</li><li>Phone Number</li><li>Partner Name</li><li>Description of the issue:<ul><li>Impacted channel / Social Network account</li><li>Approximate start/end/occurrences of the issue</li><li>Observed/expected behaviour</li></ul></li></ul></div></div></div></div></div></div></div></div>
        </>
        
       
    )
}
